import { isValidJson } from '@/src/api';
import type { ApiResponse } from '@/src/core/rest-api/types';
import type { FusionConfigExtended } from '@/src/domain/entities';

export const fusion = {
  getById: async (id: string, clientId: string, cookie: string | null): Promise<FusionConfigExtended | undefined> => {
    const response = await fetch(`${process.env.NEXT_PUBLIC_API_BASE_URL}/fusion-configs/${id}?clientId=${clientId}`, {
      headers: {
        'x-csrf-token': `${process.env.SERIVCE_X_CSRF_TOKEN}`,
        Cookie: `${cookie}`
      }
    });
    if (response.ok) {
      const responseText = await response.text();

      if (isValidJson(responseText)) {
        const data: ApiResponse<FusionConfigExtended> = JSON.parse(responseText);

        return data.data;
      }
    }

    return undefined;
  },
  getAll: async (clientId: string, cookie: string | null): Promise<FusionConfigExtended[]> => {
    const response = await fetch(`${process.env.NEXT_PUBLIC_API_BASE_URL}/fusion-configs?clientId=${clientId}`, {
      headers: {
        'x-csrf-token': `${process.env.SERIVCE_X_CSRF_TOKEN}`,
        Cookie: `${cookie}`
      }
    });
    if (response.ok) {
      const responseText = await response.text();

      if (isValidJson(responseText)) {
        const data: ApiResponse<FusionConfigExtended[]> = JSON.parse(responseText);

        return (data.success && data.data) || [];
      }
    }

    return [];
  },
  create: async (data: Partial<FusionConfigExtended>): Promise<FusionConfigExtended | undefined> => {
    const response = await fetch(`${process.env.NEXT_PUBLIC_API_BASE_URL}/fusion-configs`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-csrf-token': `${process.env.SERIVCE_X_CSRF_TOKEN}`
      },
      body: JSON.stringify(data)
    });
    if (response.ok) {
      const responseText = await response.text();

      if (isValidJson(responseText)) {
        const data: ApiResponse<FusionConfigExtended> = JSON.parse(responseText);

        return (data.success && data.data) || undefined;
      }
    }

    return undefined;
  },
  update: async (data: Partial<FusionConfigExtended>): Promise<FusionConfigExtended | undefined> => {
    const response = await fetch(`${process.env.NEXT_PUBLIC_API_BASE_URL}/fusion-configs/${data.id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'x-csrf-token': `${process.env.SERIVCE_X_CSRF_TOKEN}`
      },
      body: JSON.stringify(data)
    });
    if (response.ok) {
      const responseText = await response.text();

      if (isValidJson(responseText)) {
        const data: ApiResponse<FusionConfigExtended> = JSON.parse(responseText);

        return (data.success && data.data) || undefined;
      }
    }

    return undefined;
  },
  delete: async (id: number): Promise<boolean> => {
    const response = await fetch(`${process.env.NEXT_PUBLIC_API_BASE_URL}/fusion-configs/${id}`, {
      method: 'DELETE',
      headers: { 'x-csrf-token': `${process.env.SERIVCE_X_CSRF_TOKEN}` }
    });
    return response.ok;
  }
};
